<div class="row-custom">
  <div class="menu-left">
    <form id="vibrationGraphForm"  #ngForm="ngForm" (ngSubmit)="onSubmit(ngForm)">
      <div class="col-custom">
        <div class="form-group">
          <label for="drp">{{'GLOBAL.PERIODE' | translate}}</label>
          <mat-date-range-input [rangePicker]="vibrationRangePicker" [ngClass]="{'error-value': periodeSelectionnee == undefined && showError}">
            <input matStartDate placeholder="{{'GLOBAL.SELECT_PERIODE_GRAPHIQUE' | translate}}"
              [(ngModel)]="rangeStart" name="drpStart" readonly
              (dateChange)="onDateRangeChanged()" (click)="vibrationRangePicker.open()" (focus)="vibrationRangePicker.open()">
            <input matEndDate placeholder="{{'GLOBAL.SELECT_PERIODE_GRAPHIQUE' | translate}}"
              [(ngModel)]="rangeEnd" name="drpEnd" readonly
              (dateChange)="onDateRangeChanged()" (click)="vibrationRangePicker.open()" (focus)="vibrationRangePicker.open()">
          </mat-date-range-input>
          <mat-date-range-picker #vibrationRangePicker></mat-date-range-picker>
          </div>
          <div class="form-group">
            <label for="drp">{{'GLOBAL.PERIODE_PREDEFINIE' | translate}}</label>
            <ng-select [items]="tabPeriodes"
              [multiple]="false"
              [closeOnSelect]="true"
              bindLabel="nom"
              bindValue="valeur"
              placeholder="{{'GLOBAL.PERIODE_PREDEFINIE' | translate}}"
              name="selectPeriode"
              id="selectPeriode"
              [(ngModel)]="periodeSelectionnee"
              (change)="onChangePeriode()"
              [clearable]="false"
              [ngClass]="{'error-value': periodeSelectionnee == undefined && showError}"
            ></ng-select>
          </div>
          <div class="form-group">
            <label for="selectPtControl">{{'CONTROL_POINT.CONTROL_POINT' | translate}}</label>
            <ng-select [items]="tabControlPoints"
              [multiple]="true"
              [closeOnSelect]="true"
              [searchable]="true"
              bindLabel="name"
              placeholder="{{'CONTROL_POINT.CONTROL_POINT' | translate}}"
              name="selectPtControl"
              id="selectPtControl"
              [(ngModel)]="ptControlSelectionnes"
              class="custom"
              [clearable]="false"
              [ngClass]="{'error-value': ptControlSelectionnes.length < 1 && showError}"
              required
              >
            </ng-select>
          </div>


        </div>
      </form>

      <div class="btn-box">
        <div class="floating-action-button" (click)="clearAll()" >
          <i class="fas fa-redo-alt"></i>
        </div>
        <div class="floating-action-button" (click)="openModalNomGraph()" >
          <i class="fas fa-save"></i>
        </div>
        <button form="vibrationGraphForm" type="submit"  class="floating-action-button" >
          <i class="fas fa-play"></i>
        </button>
      </div>

    </div>

    @if (showIcon) {
      <div class="chart-box-icon">
        <i class="fas fa-chart-line"></i>
      </div>
    }

    @if (!showIcon) {
      <div  class="chart-box">
        @if (lineChartData) {
          <canvas baseChart
            [datasets]="lineChartData?.datasets"
            [options]="lineChartOptions"
            class="chart">
          </canvas>
        }
      </div>
    }

  </div>

  <div bsModal #modalNomGraph="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop: 'static'}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <form #saveForm="ngForm" (ngSubmit)="save($event)">
            <div class="form-group">
              <label for="nomGraph">{{'GLOBAL.NOM_GRAPHIQUE' | translate}}</label>
              <input type="text" class="form-control" name="nomGraph" id="nomGraph" maxlength="50" />
            </div>
            <div class="btn-toolbar justify-content-between">
              <div class="btn-group" role="group">
                <button type="submit" class="btn btn-outline-success">{{'GLOBAL.VALIDER' | translate}}</button>
              </div>
              <div class="btn-group" role="group">
                <button type="button" class="btn btn-secondary" (click)="modalNomGraph.hide()">{{'GLOBAL.ANNULER' | translate}}</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div bsModal #modalDejaAjoute="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name" [config]="{backdrop:'static'}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body text-center">
          <p>{{'GLOBAL.GRAPHIQUE_DEJA_AJOUTE' | translate}}</p>
          <button type="button" class="btn btn-primary" (click)="modalDejaAjoute.hide()">{{'GLOBAL.OK' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
